import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

const homeLinks = [
  { label: "Services", href: "/#services" },
  { label: "How It Works", href: "/#how-it-works" },
  { label: "Overstock", href: "/#overstock" },
  { label: "Contact", href: "/#contact" },
];

export default function BlogNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white border-b border-[#D9E2EC]" : "bg-white border-b border-[#D9E2EC]"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-16">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <div className="w-8 h-8 rounded-lg bg-[#C9A227] flex items-center justify-center">
            <i className="ri-links-line text-white text-base"></i>
          </div>
          <span className="font-bold text-lg tracking-tight text-[#222831]">LTF Sourcing</span>
        </Link>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-7">
          {homeLinks.map((link) => (
            <li key={link.label}>
              <a
                href={link.href}
                className="text-sm font-medium text-[#3A506B] hover:text-[#222831] transition-colors whitespace-nowrap"
              >
                {link.label}
              </a>
            </li>
          ))}
          <li>
            <Link
              to="/blog"
              className="text-sm font-semibold text-[#C9A227] whitespace-nowrap"
            >
              Blog
            </Link>
          </li>
        </ul>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => navigate("/#contact")}
            className="text-sm font-semibold px-5 py-2 rounded-full bg-[#C9A227] text-white hover:bg-[#b08f1e] transition-colors cursor-pointer whitespace-nowrap"
          >
            Get a Quote
          </button>
        </div>

        {/* Mobile Toggle */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-[#222831] cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-[#D9E2EC] px-6 py-4 flex flex-col gap-3">
          {homeLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-sm font-medium text-[#3A506B] hover:text-[#222831] whitespace-nowrap"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <Link
            to="/blog"
            className="text-sm font-semibold text-[#C9A227] whitespace-nowrap"
            onClick={() => setMenuOpen(false)}
          >
            Blog
          </Link>
          <a
            href="/#contact"
            className="mt-2 text-sm font-semibold px-5 py-2 rounded-full bg-[#C9A227] text-white text-center whitespace-nowrap"
            onClick={() => setMenuOpen(false)}
          >
            Get a Quote
          </a>
        </div>
      )}
    </nav>
  );
}